import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import AttendeeCatalog from "@/components/AttendeeCatalog";

export default function AttendeeCatalogPage() {
  return (
    <div className="space-y-4" data-testid="attendee-catalog-page">
      <Link
        to="/admin/events"
        className="inline-flex items-center gap-1 text-xs font-body text-[#A1A9B8] hover:text-white"
        data-testid="attendee-catalog-back"
      >
        <ArrowLeft className="h-3 w-3" /> Back to Events
      </Link>
      <AttendeeCatalog />
    </div>
  );
}
